import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  BUS_ASSIGNMENT_SCHEDULE_PATH,
  BUS_BODY_WORK_PATH,
  BUS_CHASSIS_PATH,
  BUS_PATH,
  BUS_UNIT_PATH,
  DOCUMENT_TYPE_PATH,
  NEW_BUS_ASSIGNMENT_SCHEDULE_PATH,
  NEW_BUS_BODY_WORK_PATH,
  NEW_BUS_CHASSIS_PATH,
  NEW_BUS_PATH,
  NEW_DOCUMENT_TYPE_PATH,
  NEW_SERVICE_TYPE_PATH,
  REGISTERED_BUS_FLEET_PATH,
  SEAT_MAP_ELEMENT_PATH,
  SERVICE_TYPE_PATH,
} from '../../../config/paths';
import BusHome from './BusHome';
import RegisteredBusses from './registered-bus/RegisteredBusses';
import RegisteredBus from './registered-bus/RegisteredBus';
import NewRegisteredBus from './registered-bus/NewRegisteredBus';
import EditRegisteredBus from './registered-bus/EditRegisteredBus';
import BusAssignmentSchedules from './bus-assignment-schedule/BusAssignmentSchedules';
import BusAssignmentSchedule from './bus-assignment-schedule/BusAssignmentSchedule';
import NewBusAssignmentSchedule from './bus-assignment-schedule/NewBusAssignmentSchedule';
import EditBusAssignmentSchedule from './bus-assignment-schedule/EditBusAssignmentSchedule';
import RegisteredBusFleets from './registered-bus-fleet/RegisteredBusFleets';
import BusesChassis from './bus-chassis/BusesChassis';
import BusChassis from './bus-chassis/BusChassis';
import NewBusChassis from './bus-chassis/NewBusChassis';
import EditBusChassis from './bus-chassis/EditBusChassis';
import BusesBodywork from './bus-bodywork/BusesBodywork';
import NewBusBodywork from './bus-bodywork/NewBusBodywork';
import BusBodywork from './bus-bodywork/BusBodywork';
import EditBusBodyWork from './bus-bodywork/EditBusBodywork';
import ServiceTypes from './service-type/ServiceTypes';
import ServiceType from './service-type/ServiceType';
import NewServiceType from './service-type/NewServiceType';
import EditServiceType from './service-type/EditServiceType';
import DocumentTypes from './document-type/DocumentTypes';
import NewDocumentType from './document-type/NewDocumentType';
import DocumentType from './document-type/DocumentType';
import EditDocumentType from './document-type/EditDocumentType';
import SeatMapElements from './seat-map-element/SeatMapElements';

const BusUnit = () => (
  <Switch>
    <Route exact path={BUS_UNIT_PATH} component={BusHome} />
    <Route exact path={BUS_PATH} component={RegisteredBusses} />
    <Route exact path={NEW_BUS_PATH} component={NewRegisteredBus} />
    <Route exact path={`${BUS_PATH}/:id`} component={RegisteredBus} />
    <Route exact path={`${BUS_PATH}/:id/edit`} component={EditRegisteredBus} />
    <Route exact path={BUS_CHASSIS_PATH} component={BusesChassis} />
    <Route exact path={NEW_BUS_CHASSIS_PATH} component={NewBusChassis} />
    <Route exact path={`${BUS_CHASSIS_PATH}/:id`} component={BusChassis} />
    <Route exact path={`${BUS_CHASSIS_PATH}/:id/edit`} component={EditBusChassis} />
    <Route exact path={BUS_BODY_WORK_PATH} component={BusesBodywork} />
    <Route exact path={NEW_BUS_BODY_WORK_PATH} component={NewBusBodywork} />
    <Route exact path={`${BUS_BODY_WORK_PATH}/:id`} component={BusBodywork} />
    <Route exact path={`${BUS_BODY_WORK_PATH}/:id/edit`} component={EditBusBodyWork} />
    <Route exact path={SERVICE_TYPE_PATH} component={ServiceTypes} />
    <Route exact path={NEW_SERVICE_TYPE_PATH} component={NewServiceType} />
    <Route exact path={`${SERVICE_TYPE_PATH}/:id`} component={ServiceType} />
    <Route exact path={`${SERVICE_TYPE_PATH}/:id/edit`} component={EditServiceType} />
    <Route exact path={DOCUMENT_TYPE_PATH} component={DocumentTypes} />
    <Route exact path={NEW_DOCUMENT_TYPE_PATH} component={NewDocumentType} />
    <Route exact path={`${DOCUMENT_TYPE_PATH}/:id`} component={DocumentType} />
    <Route exact path={`${DOCUMENT_TYPE_PATH}/:id/edit`} component={EditDocumentType} />
    <Route exact path={SEAT_MAP_ELEMENT_PATH} component={SeatMapElements} />
    <Route
      exact
      path={BUS_ASSIGNMENT_SCHEDULE_PATH}
      component={BusAssignmentSchedules}
    />
    <Route
      exact
      path={NEW_BUS_ASSIGNMENT_SCHEDULE_PATH}
      component={NewBusAssignmentSchedule}
    />
    <Route
      exact
      path={`${BUS_ASSIGNMENT_SCHEDULE_PATH}/:id`}
      component={BusAssignmentSchedule}
    />
    <Route
      exact
      path={`${BUS_ASSIGNMENT_SCHEDULE_PATH}/:id/edit`}
      component={EditBusAssignmentSchedule}
    />
    <Route exact path={REGISTERED_BUS_FLEET_PATH} component={RegisteredBusFleets} />
  </Switch>
);

export default BusUnit;
